import { getFirestore, collection, addDoc, Timestamp } from "firebase/firestore";
import { app } from "../config";

const db = getFirestore(app);

// Function to create a new entry in the sellEventRegistration table
const submitMPSApplication = async (registrationData, eventId) => {
  try {
    // Build the event registration object with the provided fields
    const MPSEventRegistrationProfile = {
      userId: registrationData.userId,
      eventId: eventId.id,
      fullName: registrationData.fullName,
      businessEmail: registrationData.businessEmail,
      businessName: registrationData.businessName,
      companyLogoURL: registrationData.companyLogoURL,
      businessType: registrationData.businessType,
      businessPhoneNumber: registrationData.businessPhoneNumber,
      smsPhoneNumber: registrationData.smsPhoneNumber,
      businessDescription: registrationData.businessDescription,
      businessWebsite: registrationData.businessWebsite,
      businessSocialProfiles: registrationData.businessSocialProfiles || {},
      businessDocuments: registrationData.businessDocuments || [],
      datesApplyingFor: registrationData.datesApplyingFor || [],
      boothNumber: registrationData.boothSize,
      additionalUserInfo: registrationData.additionalUserInfo,
      MPSanswers: registrationData?.MPSanswers,
      applicationStatus: "Applied",
      paymentStatus: "Not Paid",
      treeDonationOptIn: registrationData.treeDonationOptIn || false,
      treeDonationAmount: registrationData.treeDonationAmount || 0,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now(),
    };

    // Add the document to the sellEventRegistration collection in Firestore, automatically generating a new document ID
    const docRef = await addDoc(collection(db, "mpsEventRegistration"), MPSEventRegistrationProfile);
    console.log("Document written with ID: ", docRef.id);
    return { success: true, documentId: docRef.id };

  } catch (error) {
    console.error("Error adding document: ", error);
    return { success: false, message: error.message };
  }
};

export { submitMPSApplication };
